import React from 'react';
import { useNavigate } from "react-router-dom";
import {Box, Grid, Button, Link} from '@material-ui/core';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import {MetaTags} from 'react-meta-tags';
import {API_URL} from '../utils/EnvVars';
import Cookies from 'js-cookie';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { addUser } from '../store/user.actions';


  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);
	const isloggedin = Cookies.get('isrwadminloggedin');
	const dispatch = useDispatch();
	const [userId, setUserId] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	var vertical='top',horizontal='center';

	if(isloggedin){
		navigate('/free-company');
		///window.location.href='/lead/dashboard';
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function login(){
		///alert('Login Now');
		if(!userId){
			setShowAlert(true);
			setAlertMessage("Enter your user-id.");			
			return false;
		}else if(!password){
			setShowAlert(true);
			setAlertMessage("Enter your password.");			
			return false;	
		}else{
			document.getElementById('waitloginbtnid').style.display='';
			document.getElementById('loginbtnid').style.display='none';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  
			const data = new FormData();
			data.append('userId', userId);
			data.append('password', password);
			data.append('device', 'web');
			axios.post(API_URL+'/app/adminlogin', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response);
				if(response && response.status===200 && response.data && response.data.responseTxt==="success"){					
					dispatch(addUser(response.data.obj));
					Cookies.set('isrwadminloggedin', 1, { expires: new Date(new Date().getTime() + 3600000*24*7) });
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					///window.location.href="/lead/dashboard";
					///navigate('/dashboard');
					navigate('/free-company');
					
				}else if(response && response.status===200 && response.data && response.data.responseTxt==="NotActive"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Your user-id is not active.");			
					return false;

				}else if(response && response.status===200 && response.data && response.data.responseTxt==="InvalidUser"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Your user-id or password is invalid.");			
					return false;

				}else if(response && response.status===200 && response.data && response.data.responseTxt==="SoftwareExpired"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Oops! Your subscription has been expired. Contact to BizOfficer to resume your service.");			
					return false;
					
				}else{
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Failed to login");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})
		}  
	}
	
	// React.useEffect(() => {		
	// 	document.body.background = '/login-bg-'+Math.ceil( Math.random() * 3 )+'.jpg';
	// 	document.body.style.backgroundSize = "cover";			
	// }, []); 

	function onEnter(event){
		if(event.key === 'Enter'){
			login();
		}
	}

		return (
			<div> 
				<MetaTags>
            		<title>Login</title>
            		<meta name="description" content="Login" />
          		</MetaTags>
				
				<Box className="loginBGImg" style={{backgroundColor:"#2a2a2a", height: '100vh',  overflow: 'hidden'}} >					
				<span id="organisationIdSpanId" hidden>{userObj.organisationId}</span>
				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={15000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Box spacing={2} >
						<Grid container style={{justifyContent: 'center'}} spacing={2}>
							<Grid item className="dhslogin" md={6} xs={12}>

								<Grid className="flex-container ">								
									<Grid md={12} xs={12}>
										<img alt="logo" src={process.env.PUBLIC_URL+"/logo.png"} style={{marginTop:20}} />
									</Grid>
									<Grid md={12} xs={12} style={{marginTop:15}} >
										<TextField 
											onKeyPress={(event)=>{onEnter(event)}}
											onChange={event => setUserId(event.target.value)}
											color="warning"
											id="outlined-userid-input"
											label="Mobile or Email"
											fullWidth	
											variant="outlined"
										/>
									</Grid>
									<Grid md={12} xs={12} style={{marginTop:15}} >
										<TextField
											onKeyPress={(event)=>{onEnter(event)}}
											onChange={event => setPassword(event.target.value)}
											color="warning"
											id="outlined-password-input"
											label="Password"
											type="password"											
											fullWidth	
											variant="outlined"							
										/>
									</Grid>
									<Grid md={12} xs={12} style={{marginTop:15}}>
										<Link href="/lead/forgotpassword" className="loginfrgot" >Forgot Password?</Link>
									</Grid>
									<Grid md={12} xs={12}>
										<Button id="loginbtnid" onClick={()=>{login()}} className="loginbtn" variant="contained">LOGIN</Button>
										<LoadingButton 
											className="loginbtn"
											loading
											loadingPosition="start"											
											variant="outlined"
											color="secondary"
											id="waitloginbtnid" 
											style={{textTransform: 'none',display:'none'}}
										>
											Wait...
										</LoadingButton>
									</Grid>

									{/* <Grid md={12} xs={12}>
										<Link href="/subscription/create-account" className="loginfrgot" >New to BizOfficer? Create your account, Its Free</Link>
									</Grid> */}
								
								</Grid>
							

							</Grid>
											

						</Grid>
				</Box>




				</Box>
				
			</div>
		);
 
}